import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Link as MaterialUILink } from '@material-ui/core';

import { ITitle, IText, ILink } from 'interfaces';
import { StyledText } from './Texts.styles';

export const Title = ({
  color = 'info',
  decoration = 'none',
  textCase = 'title',
  isParagraph = false,
  weight = 'bold',
  label,
  size = 'h3',
  position = 'left',
  children,
  required = false,
  ...otherProps
}: ITitle): JSX.Element => (
  <StyledText
    fontWeight={weight}
    fontCase={textCase}
    textColor={color}
    textDecoration={decoration}
    variant={size}
    align={position}
    paragraph={isParagraph}
    {...otherProps}
  >
    {children || label}
    {required && '*'}
  </StyledText>
);

export const Text = ({
  color = 'info',
  decoration = 'none',
  textCase = 'sentence',
  isParagraph = true,
  weight = 'normal',
  position = 'left',
  size = 'body1',
  text,
  children,
  ...otherProps
}: IText): JSX.Element => (
  <StyledText
    fontWeight={weight}
    fontCase={textCase}
    textColor={color}
    textDecoration={decoration}
    variant={size}
    align={position}
    paragraph={isParagraph}
    {...otherProps}
  >
    {children || text}
  </StyledText>
);

export const Link = ({
  color,
  decoration = 'underline',
  textCase = 'sentence',
  isParagraph = true,
  weight = 'normal',
  position = 'left',
  size = 'body1',
  text,
  children,
  to,
  url,
  onClick,
  target = '',
  rel = '',
  textProps = {},
  ...otherProps
}: ILink): JSX.Element => (
  <>
    {url ? (
      <MaterialUILink
        href={url}
        onClick={onClick}
        target={target}
        rel={rel}
        {...otherProps}
      >
        <StyledText
          fontWeight={weight}
          fontCase={textCase}
          textColor={color}
          textDecoration={decoration}
          variant={size}
          align={position}
          paragraph={isParagraph}
          {...textProps}
        >
          {children || text}
        </StyledText>
      </MaterialUILink>
    ) : (
      <ReactRouterLink to={`${to}`} onClick={onClick} {...otherProps}>
        <StyledText
          fontWeight={weight}
          fontCase={textCase}
          textColor={color}
          textDecoration={decoration}
          variant={size}
          align={position}
          paragraph={isParagraph}
          {...textProps}
        >
          {children || text}
        </StyledText>
      </ReactRouterLink>
    )}
  </>
);
